import produce from 'immer';
import merge from 'lodash/merge';
import union from 'lodash/union';
import { IPaginatedStoreResource } from '../helpers/pagination';
import { initialRootState } from '../initialRootState';
import { EPhotoRevealsActionType, TPhotoRevealsActions } from './actions';
import { TPhotoRevealsEntries } from './types';

export interface IPhotoRevealsState extends IPaginatedStoreResource {
  entries: TPhotoRevealsEntries;
  list: string[];
}

export const photoRevealsReducer = (
  currentState: IPhotoRevealsState = initialRootState.photoReveals,
  action: TPhotoRevealsActions
): IPhotoRevealsState =>
  produce(currentState, draft => {
    switch (action.type) {
      case EPhotoRevealsActionType.RESET:
        draft.list = [];
        draft.entries = {};
        draft.meta = {
          currentPage: 0,
        };
        break;
      case EPhotoRevealsActionType.GET_SUCCESS:
        merge(draft.entries, action.payload.entities.photoReveals);
        draft.list = union(draft.list, action.payload.result.data);
        draft.meta = {
          currentPage: action.payload.result.meta.pagination.current_page,
          total: action.payload.result.meta.pagination.total,
        };
        break;
      default:
        break;
    }
  });
